import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-kimba',
  templateUrl: './kimba.component.html',
  styleUrls: ['./kimba.component.scss']
})
export class KimbaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
